<template>
  <div v-if="quiz && quiz.Questions">
    <div v-for="question in quiz.Questions" v-bind:key="question.SequenceNumber" class="card mb-4 box-shadow text-center">
      <div class="card-header" v-bind:class="{ 'text-success': (gameState && (question.SequenceNumber == gameState.CurrentQuestion))}">
        <h5 class="my-0 font-weight-normal">{{ question.QuestionText }}</h5>
      </div>
      <div class="card-body">
        <!-- Multiple choice -->
        <div v-if="question.$type == 'RealTimeQuiz.Models.MultipleChoiceQuestion, RealTimeQuiz'">
          <div v-for="answer in question.Answers" v-bind:key="answer.Value">
            <li v-bind:class="{'text-success' : answer.IsCorrect}">{{ answer.Value }}: {{ answer.Text }}</li>
          </div>
        </div>
        <!-- Open question -->
        <div v-if="question.$type == 'RealTimeQuiz.Models.OpenQuestion, RealTimeQuiz'">
          Antwoord: {{ question.Answer }}
        </div>
        <!-- Amount question -->
        <div v-if="question.$type == 'RealTimeQuiz.Models.AmountQuestion, RealTimeQuiz'">
          <p>Antwoord: {{ question.Answer }}<br />
          Afwijking: {{ question.AllowedDeviation }}</p>
        </div>
        <!-- True/false question -->
        <div v-if="question.$type == 'RealTimeQuiz.Models.TrueFalseQuestion, RealTimeQuiz'">
          <p>Antwoord: {{ question.Answer }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'QuestionsAdmin',
  computed: {
    ...mapGetters({
      quiz: 'quiz/quiz',
      gameState: 'quiz/gameState'
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
